const CAMPAIGN_KEYS = ['name', 'source', 'medium', 'term', 'content'] as const;
type CampaignKey = (typeof CAMPAIGN_KEYS)[number];

export type UsageTrackerContextCampaign = {
  [key in CampaignKey]: string;
};

function isOfType(obj: unknown): obj is UsageTrackerContextCampaign {
  if (!obj || typeof obj !== 'object') {
    return false;
  }
  const objKeys = Object.keys(obj);
  return objKeys.length === CAMPAIGN_KEYS.length && objKeys.every(key => CAMPAIGN_KEYS.includes(key as CampaignKey));
}

export const UsageTrackerContextCampaign = {
  isOfType,
};
